import NewsfeedContentEmptyStateSvg from '@web/assets/svg/Misc/empty-newsfeed-content.svg';
import { NewsfeedEmptyState } from '@web/newsfeed/EmptyStates/NewsfeedEmptyState/NewsfeedEmptyState';
import { Page } from '@web/newsfeed/types/Page';

import { useNewsfeedEmptyStates } from './NewsfeedEmptyPageStates.hooks';
import { EmptyStateType } from './NewsfeedEmptyPageStates.types';

type Props = {
  isAdmin: boolean;
  emptyStateType: EmptyStateType;
  currentPage: Page;
};
const NewsfeedEmptyStates = ({ isAdmin, emptyStateType, currentPage }: Props) => {
  const { textFirstLine, textSecondLine } = useNewsfeedEmptyStates({
    isAdmin,
    emptyStateType,
    currentPage,
  });

  return (
    <NewsfeedEmptyState
      firstLine={textFirstLine}
      secondLine={textSecondLine}
      icon={<NewsfeedContentEmptyStateSvg />}
    />
  );
};

export default NewsfeedEmptyStates;
